<template>
  <div class="item">
    <div>
      <div class="item-img">
        <img :alt="shopItem.title" :src="shopItem.img" style="opacity: 1" />
      </div>
      <h6>{{ shopItem.title }}</h6>
      <h3 style="padding: 0 24px">{{ shopItem.info }}</h3>

      <div class="item-btns clearfix">
        <span class="item-gray-btn"><a target="_blank" @click="goItem(shopItem)">查看详情</a> </span><span
          class="item-blue-btn" @click="addCarPanel(shopItem)">加入购物车
        </span>
      </div>

      <div class="item-price clearfix">
        <i>¥</i><span>{{ shopItem.price }}</span>
      </div>
      <div class="discount-icon">false</div>
      <div class="item-cover">
        <a target="_blank" @click="goItem(shopItem)"></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      itemIndex: 0, //圆点对应的商品图片下标
    };
  },
  props: ["shopItem"],
  methods: {
    goItem(obj) {
      // 1. 序列化对象 + URI 编码
      const encodedData = encodeURIComponent(JSON.stringify(obj));

      // 2. 构造完整 URL（注意 Hash 模式路径在 # 后）
      const url = `${window.location.origin}/#/item?itemData=${encodedData}`;

      // 3. 新窗口打开
      window.open(url, '_blank');
    },
    tableIndex(index) {
      this.itemIndex = index;
    },
    addCarPanel(data) {
      console.log(data, 6566);

      this.$store.dispatch("addCar", data);
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/components/shop-item.vue